import PropTypes from 'prop-types'
import React from 'react'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import { AccordionDetails } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'
import MuiAccordionSummary from '@material-ui/core/AccordionSummary'
import MuiAccordion from '@material-ui/core/Accordion'
import clsx from 'clsx'
import trackingAccordionStyle from '../../../configs/style/trackingAccordionStyle'

const Accordion = withStyles(trackingAccordionStyle.accordion)(MuiAccordion)
const AccordionSummary = withStyles(trackingAccordionStyle.accordionSummary)(MuiAccordionSummary)

const TrackingAccordion = ({ onChange, expanded, index, date, title, content }) => {
  return (
    <Accordion
      className="md:rounded-xl p-0 bg-blue-350 shadow-none"
      TransitionProps={{ unmountOnExit: true }}
      expanded={expanded}
      onChange={onChange}
    >
      <AccordionSummary
        className="p-6 md:p-8 relative"
        expandIcon={<ExpandMoreIcon fontSize="large" />}
        aria-controls={`panel${index}-content`}
        id={`panel${index}-header`}
      >
        <div className="w-full">
          <p className="text-base">{date}</p>
          <p className="font-bold text-xl">{title}</p>
        </div>
      </AccordionSummary>
      <div className={clsx('md:-mt-2 mb-6 mx-6 md:mx-8 bg-neutral-350 h-0.5', expanded ? 'block' : 'hidden')} />
      <AccordionDetails className={clsx('block px-6 md:px-8 pb-6 md:pb-8', expanded ? 'opacity-100' : 'opacity-0')}>
        {content}
      </AccordionDetails>
    </Accordion>
  )
}
export default TrackingAccordion

TrackingAccordion.propTypes = {
  onChange: PropTypes.func,
  expanded: PropTypes.bool,
  index: PropTypes.number,
  date: PropTypes.string,
  title: PropTypes.string,
  content: PropTypes.node
}
